import { getCard } from 'app/store/model/selectors/getCard';
import { IApplicationState } from 'app/types/types';
import { connect } from 'react-redux';
import { ICardActionsEvents, ICardActionsFields } from '../components/types';
import { ICardActionsHOCProps } from './types';
import { CardActions } from '../components/CardActions';
import { onCardArchive } from './events/onCardArchive';
import { onCardCopy } from './events/onCardCopy';
import { onCardDelete } from './events/onCardDelete';
import { onClick } from './events/onClick';
import { onUnarchive } from './events/onUnarchive';
import { getCardDone } from 'app/store/model/selectors/getCardDone';
import { onDone } from './events/onDone';
import { onEdit } from './events/onEdit';
import { getCardCanBeSetDone } from 'app/store/model/selectors/getCardCanBeSetDone';
import { getAuthUser } from 'app/store/model/authUser/selectors/getAuthUser';
import { SegmentCardSourceValue } from 'app/middlewares/segment/trackEntities/cardEvents';
import { getBoardPermissions } from 'app/store/model/selectors/getBoardPermissions';
import { onRename } from './events/onRename';
import { TStatus } from 'app/types/model';
import { getShowProFeaturesTrial } from 'app/store/model/authUser/selectors/getShowProFeaturesTrial';
import { getList } from 'app/store/model/list/selectors/getList';
import { onOpenPreviewSettings } from './events/onOpenPreviewSettings';
import {
    onGetLinkCard
} from 'app/view/react_components/main/kanbanView/components/CardActions/hocs/events/onGetLinkCard';
import {
    getIsUserEssentialPlanOnly
} from '../../../../../../../store/model/authUser/selectors/getIsUserEssentialPlanOnly';

const mapStateToProps = (
    state: IApplicationState,
    { cardId, boardId, portalId, isShowCardPreview, isShowColorTags }: ICardActionsHOCProps
): ICardActionsFields => {
    const { allowArchive} = getAuthUser(state);
    const card = getCard(state, cardId);
    const { listId, status, colorIds = [] } = card;
    const isArchive = status === TStatus.STATUS_ARCHIVE;
    const list = getList(state, listId);

    return {
        isArchive,
        canDone: !getCardDone(state, cardId) && getCardCanBeSetDone(state, cardId),
        cardId,
        portalId,
        allowArchive,
        isReadonly: !getBoardPermissions(state, boardId).authPermissions.allowEdit,
        listId,
        listOrder: list.orderNumber,
        isEssentialFeature: getIsUserEssentialPlanOnly(state),
        isProFeature: getShowProFeaturesTrial(state),
        isShowCardPreview,
        isShowColorTags,
    };
};

const mapDispatchToProps = (
    dispatch: any,
    ownProps: ICardActionsHOCProps
): ICardActionsEvents => {
    const {boardId, cardId, source = SegmentCardSourceValue.DROPDOWN, closePanelOnDelete, openColorTags } = ownProps;
    return {
        onCardArchive: () => dispatch(onCardArchive(boardId, cardId)),
        onCardCopy: () => dispatch(onCardCopy(cardId, source)),
        onCardDelete: () => dispatch(onCardDelete(cardId, source, closePanelOnDelete)),
        onClick: () => dispatch(onClick(source, cardId)),
        onUnarchive: () => dispatch(onUnarchive(cardId, source)),
        onDone: () => dispatch(onDone(cardId, source)),
        onEdit: () => dispatch(onEdit(cardId, source)),
        onOpenPreview: () => dispatch(onOpenPreviewSettings()),
        onRename: () => dispatch(onRename(cardId, source)),
        onGetLinkCard: () => dispatch(onGetLinkCard(cardId, boardId, source)),
        openColorTags,
    };
};
export const CardActionsHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(CardActions);

CardActionsHOC.displayName = 'CardActionsHOC';
